<template>
  <div>
    <v-row
      justify="center"
      align="center"
      v-if="serviceProvidersDetails.loading"
      style="height:50vh"
    >
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row>
    <div v-if="!serviceProvidersDetails.loading">
      <v-row class="pa-2" align="center">
        <v-btn
          :icon="$store.state.isMobile"
          :text="!$store.state.isMobile"
          color="indigo accent-3"
          @click="goBack"
          exact
        >
          <v-icon :left="!$store.state.isMobile" size="20"
            >mdi-keyboard-backspace</v-icon
          >
          <span style="font-size: 18px;" v-show="!$store.state.isMobile"
            >Back</span
          >
        </v-btn>

        <!-- <h1 class="text-color page-heading">
          {{ studentDetails.studentData.student_name }}
        </h1> -->

        <v-spacer />

        <!-- Change details to edit in service provider permission-->

        <v-btn
          v-if="
            permissions.indexOf(PermissionKeys.SERVICE_PROVIDER_DETAILS) > -1
          "
          color="indigo accent-3"
          text
          :dark="$store.state.isMobile"
          :to="{
            name: routerPath.adminPanel.children.serviceProvidersEdit.name,
            params: { id: this.$route.params.id },
          }"
        >
          <v-icon left v-show="$store.state.isMobile" size="24"
            >mdi-account-edit</v-icon
          >
          <span v-show="!$store.state.isMobile" class="title"
            >Edit Service provider Profile</span
          >
          <span v-show="$store.state.isMobile" class="title">Edit</span>
        </v-btn>
        <!-- <v-col cols="12" sm="6">
          <v-row class="mb-6" no-gutters justify="end" align="center">
            
          </v-row>
        </v-col>-->
      </v-row>

      <v-row class="mb-6" no-gutters>
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title class="color-services"
              >Primary Information</v-card-title
            >
            <v-divider class="ms-4 me-4"></v-divider>
            <v-card-text>
              <v-row class="ps-4">
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">First Name</span>
                    </v-col>
                    <v-col cols="8" sm="8" class="custom-lable-field">
                      {{ serviceProvidersDetails.firstName }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">Last Name</span>
                    </v-col>
                    <v-col cols="8" sm="8" class="custom-lable-field">
                      {{ serviceProvidersDetails.lastName }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">Email</span>
                    </v-col>
                    <v-col cols="8" class="custom-lable-field">
                      {{ formatEmail(serviceProvidersDetails.email) }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">Mobile</span>
                    </v-col>
                    <v-col cols="8" class="custom-lable-field">
                      {{ serviceProvidersDetails.phone }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">City</span>
                    </v-col>
                    <v-col cols="8" class="custom-lable-field">
                      {{ serviceProvidersDetails.city }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="mt-n2">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="4" sm="4">
                      <span class="custom-lables">Role</span>
                    </v-col>
                    <v-col cols="8" class="custom-lable-field">
                      <ul id="demo">
                        <li
                          v-for="item in serviceProvidersDetails.roles"
                          :key="item.id"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Axios from "../../../../api/BaseAxios";
  import {
    API_CLIENT_URL,
    ROUTER_URL,
    API_ADMIN_URL,
  } from "../../../../constants/urls";
  import Keys from "../../../../constants/keys";
  import PermissionKeys from "../../../../constants/PermissionKeys";
  import Helper from "../../../../helper";

  export default {
    name: "ServiceProvidersDetails",
    components: {},
    data() {
      return {
        PermissionKeys: PermissionKeys,
        Helper: Helper,
        apiUrl: API_CLIENT_URL,
        routerPath: ROUTER_URL,
        items: [],
        search: "",
        itemsTotal: 0,
        loading: true,
        firstLoad: true,
        isMobile: false,
        deletePrompt: false,
        clientId: 0,
        pagination: { sortBy: ["name"], sortDesc: [false] },
        serviceProvidersDetails: {
          firstName: "",
          lastname: "",
          email: "",
          phone: "",
          city: "",
          roles: [],
        },
      };
    },
    watch: {
      isUpdating(val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000);
        }
      },
      permissions() {
        // if (this.permissions.indexOf(this.PermissionKeys.SERVICE_PROVIDER_DETAILS) < 0) {
        //   this.$router.push({ name: "eblityLogin" });
        // }
      },
    },
    created() {
      this.getClientData();
    },
    computed: {
      ...mapGetters({
        permissions: "mainStore/getPermissions",
      }),
    },
    methods: {
      clicked() {
        // this.$router.push({
        //   name: this.routerPath.clientPanel.children.studentDetails.name,
        //   params: { id: value.id },
        // });
      },
      getColor(status) {
        if (status) return "green";
        else return "red";
      },
      getTextColor(status) {
        if (status) return "green--text";
        else return "red--text";
      },
      getClientData() {
        const self = this;

        const successHandler = (res) => {
          self.formLoading = false;
          self.serviceProvidersDetails.firstName =
            res.data.data.user_details["first_name"];
          self.serviceProvidersDetails.lastName =
            res.data.data.user_details["last_name"];
          self.serviceProvidersDetails.phone =
            res.data.data.user_details["mobile"];
          self.serviceProvidersDetails.email =
            res.data.data.user_details["email"];
          self.serviceProvidersDetails.city = res.data.data.city_details.name;
          self.serviceProvidersDetails.roles = res.data.data.roles_list;
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        let requestParams = {};
        requestParams[Keys.ID] = this.$route.params.id;

        Axios.request_GET(
          API_ADMIN_URL.serviceProvidersDetails,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      goBack() {
        Helper.goBack();
        // router.go(-1);
      },
      formatEmail(email) {
        return email != null ? email : "N/A";
      },
    },
    mounted() {},
  };
</script>
<style>
  .services-tab.v-tab.v-tab--active {
    border-radius: 5px;
    color: white !important;
    background-color: #5c648b;
  }
</style>
